import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import TopNavbar from '../components/Navbar';
import '../layout/LayoutWrapper.css';

const LayoutWrapper = () => {
     const [isExpanded, setIsExpanded] = useState(false);
     const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
     const [mobileOpen, setMobileOpen] = useState(false);
     const location = useLocation();

     useEffect(() => {
          const handleResize = () => setIsMobile(window.innerWidth < 600);
          window.addEventListener('resize', handleResize);
          return () => window.removeEventListener('resize', handleResize);
     }, []);

     const toggleSidebar = () => {
          if (isMobile) {
               setMobileOpen(open => !open);
          } else {
               setIsExpanded(expanded => !expanded);
          }
     };

     useEffect(() => {
          setIsExpanded(false);
          setMobileOpen(false);
     }, [location.pathname]);

     return (
          <div className="layout-wrapper">
               <Sidebar
                    isExpanded={isExpanded}
                    mobileOpen={mobileOpen}
                    setMobileOpen={setMobileOpen}
                    onToggle={toggleSidebar}
               />
               <div className={`main-content${isExpanded ? ' sidebar-expanded' : ''}`}>
                    <TopNavbar onToggleSidebar={toggleSidebar} />
                    <div className="page-content">
                         <Outlet />
                    </div>
               </div>
          </div>
     );
};

export default LayoutWrapper;